import React, { useEffect, useState } from "react";
import UnsupportedDevice from "../staff-app/UnsupportedDevice";

const MobileOnly = ({ children }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isMobile ? children : <UnsupportedDevice />;
};

export default MobileOnly;
